module.directive('newJobPlacementForm', function(moment, ModelService) {
    return {
        restrict: 'E',
        templateUrl: 'students/placements/newJobPlacementForm',
        scope: {
            participantId: '=',
            placementCreated: '&',
        },
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = basicForm.data = {};

            basicForm.save = function(data) {
                return ModelService.post('job_placement', {
                    participant_id: scope.participantId,
                    job_start: data.job_start,
                    employer: data.employer,
                }).then(function(placement) {
                    scope.placementCreated({placement: placement});
                });
            };
        },
    };
});
